function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export function getLocalReactUtils(React, ReactRouter, initialGlobalState = null) {
  var myExports = {};

  myExports.withNavigate = function (MyComponent) {
    return props => /*#__PURE__*/React.createElement(MyComponent, _extends({}, props, {
      navigate: ReactRouter.useNavigate()
    }));
  };

  myExports.withParams = function (MyComponent) {
    return props => /*#__PURE__*/React.createElement(MyComponent, _extends({}, props, {
      urlParams: ReactRouter.useParams()
    }));
  };

  var initialState = initialGlobalState || {};
  var UserContext = React.createContext({
    state: initialState,
    dispatch: () => null
  });

  function reducer(state, action) {
    console.debug('from reducer', state, action);

    if (action.sliceName) {
      return { ...state,
        [action.sliceName]: action.newValue
      };
    } else {
      return { ...state
      };
    }
  } // not included in withEverything (only needs to be at the top level component to provide the global state for all child/grandchild/... components)


  myExports.withProvider = function (MyComponent) {
    return props => {
      var [state, dispatch] = React.useReducer(reducer, initialState);
      return /*#__PURE__*/React.createElement(UserContext.Provider, {
        value: [state, dispatch]
      }, /*#__PURE__*/React.createElement(MyComponent, props));
    };
  };

  class GlobalStateComponent extends React.Component {
    constructor(props) {
      super(props);

      if (!props.globalState || !props.dispatch) {
        throw new Error('Hey Dev! Missing dispatch functions. You might be missing ".wrapper" in the export', this);
      }
    }

    static get wrapper() {
      return props => {
        var MyComponent = this;
        var [globalState, globalDispatch] = React.useContext(UserContext);

        var dispatch = (sliceName, newValue) => globalDispatch({
          sliceName,
          newValue
        });

        return /*#__PURE__*/React.createElement(MyComponent, _extends({
          globalState: globalState,
          dispatch: dispatch,
          navigate: ReactRouter.useNavigate(),
          urlParams: ReactRouter.useParams()
        }, props));
      };
    }

    get stateSlice() {
      return this.props.globalState[this.componentGlobalSliceName];
    }

    setStateSlice(newValues) {
      var newSlice = { ...this.stateSlice,
        ...newValues
      };
      this.props.dispatch(this.componentGlobalSliceName, newSlice);
    }

    getPrevStateSlice(prevProps, sliceName = '') {
      return prevProps.globalState[sliceName || this.componentGlobalSliceName];
    }

    getGlobalStateSlice(sliceName) {
      return this.props.globalState[sliceName];
    }

    setGlobalStateSlice(sliceName, newValues) {
      var newSlice = { ...this.getGlobalStateSlice(sliceName),
        ...newValues
      };
      this.props.dispatch(sliceName, newSlice);
    }

  }

  myExports.GlobalStateComponent = GlobalStateComponent;
  return myExports;
}
export function getReactGlobalStateUtils0(React, initialGlobalState) {
  var myExports = {};
  var initialState = initialGlobalState || {};
  var UserContext = React.createContext({
    state: initialState,
    dispatch: () => null
  });

  function reducer(state, action) {
    console.debug('from reducer', state, action);

    if (action.sliceName) {
      return { ...state,
        [action.sliceName]: action.newSlice
      };
    } else {
      return { ...state
      };
    }
  } // needs to be at the top level component to provide the global state for all child/grandchild/... components


  function GlobalStateProvider(props) {
    var {
      children
    } = props;
    var [state, dispatch] = React.useReducer(reducer, initialState);
    return /*#__PURE__*/React.createElement(UserContext.Provider, {
      value: [state, dispatch]
    }, children);
  }

  ;
  myExports.GlobalStateProvider = GlobalStateProvider; // doing it this way instead of an arrow function so it doesn't show up as "Anonymous"

  myExports.useStateSlice = sliceName => {
    var [globalState, globalDispatch] = React.useContext(UserContext);
    var globalStateRef = React.useRef(null); // doing this so that even out of date dispatch functions have access to the latest global state
    // causes errors if you have a bunch of simultaneous requests
    // like a bunch of ajax calls called at once from the start
    // when they come back, some will have the initial state instead of the latest state slice

    globalStateRef.current = globalState; // this might still have issues with out of date dispatch functions with other slices (not sliceName)
    // if that becomes an issue, then just make the new globalState here in "dispatch"
    // then in the reducer, just pass along the new global state
    // maybe I should also look into having an actual reducer too, where I would just pass in the action type/name
    // and apply the needed state. Probably only useful if I need to update a lot of fields at once

    var dispatch = newValues => {
      var newSlice = { ...globalStateRef.current[sliceName],
        ...newValues
      };
      globalDispatch({
        sliceName,
        newSlice
      });
    };

    return [globalState[sliceName], dispatch];
  };

  return myExports;
}
export function getReactGlobalStateUtils(React, initialGlobalState) {
  var myExports = {};
  var initialState = initialGlobalState || {};
  var GlobalStateContext = React.createContext({
    state: initialState,
    setState: () => null
  }); // needs to be at the top level component to provide the global state for all child/grandchild/... components

  myExports.GlobalStateProvider = function GlobalStateProvider(props) {
    var {
      children
    } = props;
    var [globalState, setGlobalState] = React.useState(initialState);
    return /*#__PURE__*/React.createElement(GlobalStateContext.Provider, {
      value: [globalState, setGlobalState]
    }, children);
  };

  myExports.useStateSlice = sliceName => {
    var [globalState, setGlobalState] = React.useContext(GlobalStateContext);

    function setStateSlice(newValues) {
      setGlobalState(currentGS => ({ ...currentGS,
        [sliceName]: { ...currentGS[sliceName],
          ...newValues
        }
      }));
    }

    return [globalState[sliceName], setStateSlice];
  };

  return myExports;
}
export var getGlobalStateUtils = getReactGlobalStateUtils;